module.exports = __webpack_public_path__ + "img/katom_yes.04ec4c88.png";